import script from "./mprn-property-lookup.vue?vue&type=script&setup=true&lang=ts"
export * from "./mprn-property-lookup.vue?vue&type=script&setup=true&lang=ts"

import "./mprn-property-lookup.vue?vue&type=style&index=0&id=77920630&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77920630"]])

export default __exports__